<template>
  <div>
    <div class="contents">
      <article class="article-header row g-0">
        <div class="col-12">
          <h5>{{ noticeview.title }}</h5>
        </div>
        <div class="d-flex flex-column flex-sm-row">
          <div class="d-flex align-items-center">
            <span class="icon badge bg-purple" v-if="noticeview.type === '1'">
              {{ $t("filter.support.notice") }}
            </span>
            <span class="icon badge bg-blue" v-if="noticeview.type === '2'">
              {{ $t("filter.support.patch") }}
            </span>
            <span class="text-capitalize text-black">{{
              noticeview.regname
            }}</span>
          </div>
          <div class="ms-sm-auto mt-2 mt-sm-0 pt-1 pt-sm-0">
            <span class="me-2 text-date">
              <i class="material-icons">date_range </i>
              {{ noticeview.timezone_date | dateformat }}
            </span>
            <span>
              <i class="material-icons">visibility</i>
              {{ noticeview.cnt | comma }}
            </span>
          </div>
        </div>
      </article>

      <article class="article-attach" v-if="noticeview.filename">
        <a :href="noticeview.download_link" class="text-truncate more">
          <i class="material-icons-outlined">file_download</i>
          <span>{{ noticeview.originname }}</span>
        </a>
      </article>

      <article class="article-body">
        <span v-html="noticeview.contents"></span>
      </article>

      <article class="article-footer">
        <div class="prev" :class="!next_post.notice_app_pk && 'no-data'">
          <router-link
            :to="{
              name: 'AppNoticeView',
              params: { noticeno: next_post.notice_app_pk },
            }"
            v-if="next_post.notice_app_pk"
          >
            <i class="material-icons-outlined"> expand_less </i>
            <span>{{ next_post.title }}</span>
          </router-link>
          <a @click="_alert($t('text.support.no_prev'))" v-else class="pointer">
            <i class="material-icons-outlined"> expand_less </i>
            <span>{{ $t("text.support.no_prev") }}</span>
          </a>
        </div>
        <div class="next" :class="!prev_post.notice_app_pk && 'no-data'">
          <router-link
            :to="{
              name: 'AppNoticeView',
              params: { noticeno: prev_post.notice_app_pk },
            }"
            v-if="prev_post.notice_app_pk"
          >
            <i class="material-icons-outlined"> expand_more </i>
            <span>{{ prev_post.title || $t("text.support.no_next") }}</span>
          </router-link>
          <a @click="_alert($t('text.support.no_next'))" v-else class="pointer">
            <i class="material-icons-outlined"> expand_more </i>
            <span>{{ $t("text.support.no_next") }}</span>
          </a>
        </div>
      </article>

      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="outline-secondary"
          :aria-label="$t('button.common.list')"
          @click="
            $router.push({
              name: 'AppNoticeList',
            })
          "
          >{{ $t("button.common.list") }}</b-button
        >
        <b-button
          size="xl"
          variant="secondary"
          :aria-label="$t('button.common.delete')"
          @click="noticeDelete"
          >{{ $t("button.common.delete") }}</b-button
        >
        <b-button
          size="xl"
          variant="primary"
          :aria-label="$t('button.common.edit')"
          @click="
            $router.push({
              name: 'AppNoticeWrite',
              params: { noticeno: $route.params.noticeno },
            })
          "
          >{{ $t("button.common.edit") }}</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import "@/filter/common";
import ax from "@/api/support";
import { myMixin } from "@/mixin/myMixin";

export default {
  name: "AppNoticeView",
  data() {
    return {
      param: {
        searchtype: this.$route.query.searchtype || 1,
        searchname: this.$route.query.searchname || "",
      },
      noticeview: {
        type: "",
        title: "",
        date: "",
        cnt: 0,
        contents: "",
        prevno: "",
        prevtitle: "",
        nextno: "",
        nexttitle: "",
        writer: "",
      },
      next_post: {},
      prev_post: {},
      noticeno: this.$route.params.noticeno || "",
    };
  },
  methods: {
    getView() {
      if (this.noticeno) {
        ax.getAppNoticeview(this.noticeno, this.param, (flag, data) => {
          if (flag) {
            this.noticeview = data.noticeview;
            this.next_post = data.next_post;
            this.prev_post = data.prev_post;
          } else {
            alert(data);
          }
        });
      }
    },
    noticeDelete() {
      ax.getAppNoticeDelete(this.noticeno, (flag, data) => {
        if (flag) {
          alert(data.message);
          // this.$notify({
          //   group: "alert",
          //   type: "success",
          //   text: data.message,
          //   speed: 1000,
          // });
          this.$router.push({
            name: "AppNoticeList",
          });
        } else {
          alert(data.message);
        }
      });
    },
  },
  created() {
    this.getView();
  },
  watch: {
    "$route.params": function () {
      this.noticeno = parseInt(this.$route.params.noticeno);
      this.getView();
    },
  },
  mixins: [myMixin],
};
</script>
